import { TAsyncThunkData } from './store.types';

export const asyncSliceDefaultInitialState: TAsyncThunkData = {
  data: null,
  isLoading: false,
  error: null,
};

export const SYNC_RETRY_INTERVAL = 1000 * 60 * 5; // 2 minutes
